import { Injectable } from '@angular/core';

import { License } from 'ut-business/types';

import * as allVersions from '../../../../assets/versions.json';
import { environment } from '../../../../environments/environment';

export interface ConfigVersions {
  windView: string;
  buildNumber: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  public readonly appName: string = environment.APP_NAME ?? '';
  public readonly buildTimeStamp: string = environment.timeStamp;
  public readonly isProduction: boolean = environment.production;
  public readonly isLocal: boolean = environment.local;
  public readonly isElectron: boolean = environment.electron;
  public readonly isCloudConnected: boolean = environment.cloudConnected;
  public readonly isEvidentConnect: boolean = !!environment.USE_CONNECT_PLATFORM;
  public readonly hasNetworkSettings: boolean = environment.networkSettings;
  public readonly hasPerformanceSettings: boolean = environment.performanceSettings;
  public readonly checkLicenseWeb: boolean = environment.checkLicenseWeb;
  public readonly licenseType: License | null = environment.licenseType;

  public apiUrl: any;

  public get version(): ConfigVersions {
    return allVersions;
  }
}
